<template>
  <div
    class="alert"
  >
    <slot />
    <div
      :class="[border && `alert-border ${color} alert-border-${border}`]"
    />
  </div>
</template>

<script>
export default {
  name: 'alert-container',
  props: {
    border: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  flex: 1 1;
  position: relative;
  padding: 16px;
  overflow: hidden;
  transition: cubic-bezier(0.4, 0, 0.2, 1);
  background: $clr-white;
  border-radius: 4px;

  .alert-border {
    border-style: solid;
    border-width: 4px;
    content: "";
    position: absolute;

    &-top {
      top: 0;
      right: 0;
      left: 0;
    }

    &-left {
      left: 0;
      top: 0;
      bottom: 0;
    }

    &-bottom {
      right: 0;
      left: 0;
      bottom: 0;
    }

    &-right {
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
}
</style>
